export interface IColaboratorsPage {
    _id: string,
    name: string,
    email:string,
    role: string,
    privilege:number
}

export const privilegeMap: { [key: number]: string } = {
    1: "Administrador general",
    2: "Recepción",
    3: "Control escolar",
};
